<template>
  <div class="fade">
    <v-dialog :value="value" @input="$emit('input')" width="400">
      <v-layout>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense class="elevation-2">
              <v-spacer></v-spacer>
              <v-toolbar-title>            
                Change Avatar
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon><v-icon @click="closeModal">close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <div class="card vue-avatar-cropper-demo text-center">
                <div class="card-body">
                  <img :src="currentAvatar" class="card-img avatar" />
                  <div class="card-img-overlay">
                    <button class="btn btn-primary btn-sm" id="pick-avatar">
                      Select a new photo
                    </button>
                  </div>
                </div>
                <avatar-cropper
                  trigger="#pick-avatar"
                  upload-form-name="avatar"
                  v-bind:upload-form-data="formData"
                  v-bind:upload-headers="uploadHeaders"
                  @uploading="handleUploading"
                  @uploaded="handleUploaded"
                  @completed="handleCompleted"
                  @error="handlerError"
                  :upload-url="uploadUrl"
                  v-bind:labels = "labels"
                />
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true">
        </loading>
    </div>
  </div>
</template>
<script>
import AvatarCropper from 'vue-avatar-cropper'
 // Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  components: {AvatarCropper, Loading},
  name: 'ChangeAvatarModal',
  props: {
    value: Boolean
  },
  data() {
    return {
      isLoading: false,
      labels: {
        submit: 'Submit',
        cancel: 'Cancel'
      },
      formData: {
        userID: this.$store.state.user.id
      },
      uploadHeaders: {
        authorization: this.$store.state.token
      }
    }
  },
  watch: {
    // userData: function (newUserData) {
    //   this.user = newUserData
    // }
  },

  computed: {
    currentAvatar: function() {
      return this.$store.state.user.profilePicture || '/static/img/avatar/user.png'
    },
    uploadUrl: function() {
      return `/api/v1/users/upload/avatar`
    }
  },

  methods: {
    closeModal() {
      this.$emit('input')
    },
    handleUploading(form, xhr) {
      console.log('uploading...')
      this.isLoading = true
    },
    handleUploaded(response) {
      this.isLoading = false
      if (response.status === 'finished') {
        this.$emit('changeAvatar', response.extra.Location)
      }
    },
    handleCompleted(response, form, xhr) {
      console.log('upload completed.')
      this.isLoading = false
    },
    handlerError(message, type, xhr) {
      console.log('Oops! Something went wrong...')
      this.isLoading = false
    }
  }
}
</script>

<style>
vue-avatar-cropper-demo {
  max-width: 18em;
  margin: 0 auto;
}
.avatar-cropper {
  /* height: 300px;
  margin-top: 90px; */
}
.avatar {
  width: 200px;
  border-radius: 50%;
  display: block;
  margin: 20px auto;
}
.cropper-crop-box,
.cropper-view-box {
  border-radius: 50%;
}

.cropper-view-box {
  box-shadow: 0 0 0 1px #39f;
  outline: 0;
}
.card-img-overlay {
  /* display: none; */
  transition: all 0.5s;
}
/* .card-img-overlay button {
  margin-top: 15vh;
} */
.card:hover .card-img-overlay {
  /* display: block; */
}
</style>



// WEBPACK FOOTER //
// ChangeAvatarModal.vue?35b80fca